module.exports = __webpack_public_path__ + "static/img/honor_8.b8ea54c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_8.jpg
// module id = qWPN
// module chunks = 0